export default {
  methods: {
    getExcelFields() {
      return {
        [this.$t("project.id")]: {
          field: "id",
          callback: (value) => {
            return value;
          },
        },
        [this.$t("project.projectNo")]: {
          field: "projectNo",
          callback: (value) => {
            return value;
          },
        },
        [this.$t("project.model")]: {
          field: "model",
          callback: (value) => {
            return value;
          },
        },
        [this.$t("project.compressorBrands")]: {
          field: "compressorBrandInfo.title",
          callback: (value) => {
            return value;
          },
        },
        [this.$t("project.compressorBrandRefrigerants")]: {
          field: "compressorBrandRefrigerantInfo.title",
          callback: (value) => {
            return value;
          },
        },
        [this.$t("project.compressorRefrigerantModels")]: {
          field: "compressorRefrigerantModelInfo.title",
          callback: (value) => {
            return value;
          },
        },
        [this.$t("project.isLocked")]: {
          field: "isLocked",
          callback: (value) => {
            return value
              ? this.$t("common.lockedText")
              : this.$t("common.unlockedText");
          },
        },
        Evaporator: {
          field: "evaporatorInfo.name",
          callback: (value) => {
            return value;
          },
        },
        Condenser: {
          field: "condenserInfo.name",
          callback: (value) => {
            return value;
          },
        },
        [this.$t("project.createdDate")]: {
          field: "createdDate",
          callback: (value) => {
            return this.$date.format(value);
          },
        },
        [this.$t("project.updatedAt")]: {
          field: "updatedDate",
          callback: (value) => {
            return this.$date.format(value || new Date());
          },
        },
        [this.$t("project.userInfo")]: {
          field: "userInfo",
          callback: (value) => {
            return value.fullname;
          },
        },
      };
    },
  },
};
